import React from 'react';

import {withSettingsContext} from '~/src/components/context/SettingsContext';
import {classNames} from '~/src/utilities/helpers/css';

import css from './TeaserContentPlaceholder.module.scss';

const TeaserContentPlaceholder = (props) => {
    const {siteArea} = props.context.settings;
    const className = classNames(css, 'teaserContent', 'placeholder', props.format.primaryGrid, props.type, siteArea);

    return (
        <div className={className}>
            <div className={css.media}>
                <div className={css.imgContainer}></div>
            </div>
            <div className={css.content}>
                <div className={css.titleHeader}></div>
                <div className={css.title}></div>
                <div className={css.lead}></div>
                <div className={css.footer}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
    );
};

export default withSettingsContext(TeaserContentPlaceholder);
